import { FC, Suspense } from 'react'
import { MapSquareIcon } from 'src/components/icons/map-square'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'
import { ParcelsTable } from 'src/v2/views/owner-reveal/insights/parcels/table'
import { OwnerParcelsCSVDownload } from 'src/v2/views/owner-reveal/insights/parcels/csv-dowload'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'
import * as atoms from 'src/v2/state/owner-reveal/entity-parcels'
import { Colors } from 'src/components/theme'
import { useCachedAtomValue } from 'src/utils/jotai'

const ParcelsContent: FC<InsightComponentProps> = ({ insight }) => {
  const entityGraphParcelsCount = useCachedAtomValue(atoms.selectedEntityGraphParcelsCount, 0)
  return (
    <InsightContainer
      insight={insight}
      title={`Parcels (${entityGraphParcelsCount})`}
      contentWithoutSpacing
      downloadable={false}
      color={Colors.primaryRed700}
      iconBgColor={Colors.primaryRed50}
      customActions={
        <Suspense fallback={null}>
          <OwnerParcelsCSVDownload />
        </Suspense>
      }>
      <ParcelsTable />
    </InsightContainer>
  )
}

export const Parcels: Insight = {
  id: 'parcels',
  tabId: COMMANDAI_IDS_MAP.ownerReveal['entity-parcels-insights-tab'],
  component: ParcelsContent,
  name: 'Parcels',
  icon: MapSquareIcon,
  linkTooltipFile: 'parcels',
  supportedResultTypes: ['owner'],
}
